import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { EncryptionAndDecryption } from 'src/app/COMMON-LOGIC/EncryptionAndDecryption';
import { CustomErrorsHandlerService } from 'src/app/_services/custom-errors-handler.service';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { PreviewSettings } from 'src/app/common-class/preview-settings';
import { PreviewData } from 'src/app/common-class/survey';
import { environment } from 'src/environments/environment';

declare var $: any;
declare const closeAlert: any;
@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.css'],
})
export class PreviewComponent implements OnInit {
  k: string;
  pgNo: number;
  isThankYou: string;
  inAppPreview: number;
  isFromSB: boolean;
  viewport: string;
  surveyFormat: number;
  PageNo: number;
  checked: boolean;
  settingId: number;
  previewSettings: PreviewSettings;
  strThankyouText: string;
  selectedPage: number;
  previewData: PreviewData;
  previewJsonData: string;
  QRImagePath: string;
  strPreviewMsg: string = 'This is only a preview. Your answers will not be recorded.';
  strPreviewTime: string = '0';
  showLoader: boolean;
  productName: string = '';
  productTitle: string = '';
  isK12: boolean;
  constructor(
    public service: ParticipationDataService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private errorsHandlerService: CustomErrorsHandlerService,
    private changeDetect: ChangeDetectorRef,
    private titleService: Title,
  ) {}

  ngOnInit(): void {
    var ua = navigator.userAgent;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)
    ) {
      let path = window.location.href.replace('preview', 'form');
      window.location.replace(path);
    } else if (navigator.maxTouchPoints > 1 && window.innerWidth < 900) {
      let path = window.location.href.replace('preview', 'form');
      window.location.replace(path);
    } else {
      const elements = document.querySelectorAll('.i-parent-div');
      elements.forEach(el => {
        (el as HTMLElement).style.display = 'block';
      });
      this.previewData = new PreviewData();
      this.GetUrlData();
      this.productTitle = environment.productName;
      if (this.productTitle == 'K12 Insight') {
        this.isK12 = true;
        this.productName = 'k12';
      }
      this.showLoader = true;
      let strDecodeUrl = 'GetSurveyPreview?k=' + this.k;
      this.service.GetDataProp(strDecodeUrl).subscribe(
        async (data) => {
          var arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await data);
          this.previewSettings = await JSON.parse(arrData);
          if (this.previewSettings.isAssessment) {
            this.strThankyouText = 'Result Page';
          } else {
            this.strThankyouText = 'Thank You Page';
          }
          this.selectedPage = 1;
          if (this.pgNo || this.isThankYou == 'true') {
            this.previewData.isPagePreview = true;
            this.previewData.PrevPgNo = this.pgNo ? this.pgNo : 999;
          } else {
            this.previewData.isPagePreview = false;
            this.previewData.PrevPgNo = this.pgNo;
          }
          this.previewData.isFromSB = this.isFromSB;
          this.previewData.surveyFormat = this.surveyFormat;
          this.previewData.viewport = this.viewport ? this.viewport : 'web';
          this.strPreviewTime = this.previewSettings.EstimatedSurveyTimeText;
          this.ShowPreviewMessage(
            this.previewData.isPagePreview ? 'true' : 'false',
            this.previewSettings.isAssessment ? 'true' : 'false',
            this.previewSettings?.EstimatedSurveyTimeText,
          );
          this.checkviewport(this.previewData.viewport);
          this.showLoader = false;
        },
        (error) => {
          this.errorsHandlerService.handleError(error);
          if (error.name == 'HttpErrorResponse') {
            window.location.replace('/sd?err=1&ng=2&cn=0');
          }
        },
      );
    }
  }

  getPreviewData() {
    return JSON.stringify(this.previewData);
  }

  getRestartToolTip() {
    return this.previewSettings?.isAssessment ? 'Restart Assessment' : 'Restart Survey';
  }

  GetUrlData(): any {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      this.k = params['k'] == '' || params['k'] == undefined ? '' : params['k'];
      this.pgNo = params['pgNo'] == '' || params['pgNo'] == undefined ? '' : params['pgNo'];
      this.isThankYou =
        params['isThankYou'] == '' || params['isThankYou'] == undefined ? '' : params['isThankYou'];
      this.inAppPreview =
        params['inAppPreview'] == '' || params['inAppPreview'] == undefined
          ? ''
          : params['isThankYou'];
      this.isFromSB =
        params['isFromSB'] == '' || params['isFromSB'] == undefined ? '' : params['isFromSB'];
      this.viewport =
        params['viewport'] == '' || params['viewport'] == undefined ? '' : params['viewport'];
      this.PageNo = params['PageNo'] == '' || params['PageNo'] == undefined ? '' : params['PageNo'];
      this.checked =
        params['checked'] == '' || params['checked'] == undefined ? '' : params['checked'];
      this.settingId =
        params['settingId'] == '' || params['settingId'] == undefined ? '' : params['settingId'];
      let lang = params['lang'] == '' || params['lang'] == undefined ? '0' : params['lang'];
      this.surveyFormat =
        params['surveyFormat'] == '' || params['surveyFormat'] == undefined
          ? ''
          : params['surveyFormat'];
    });
  }

  ngAfterViewInit() {
    var self = this;


    document.addEventListener('DOMContentLoaded', function () {
      var previewStrip = document.getElementById('previewMainStrip');
      if (previewStrip) {
        previewStrip.style.pointerEvents = 'none';
      }
    
      document.body.classList.add('full-height');

      const arrow = document.querySelector('.arrow') as HTMLElement;

      const btnRestart = document.getElementById('btnRestart') as HTMLElement;
      if (btnRestart && arrow) {
        btnRestart.addEventListener('mouseover', function () {
          arrow.style.left = '23%';
        });
      }
    
      const exitIcon = document.querySelector('.Exiticn') as HTMLElement;
      if (exitIcon && arrow) {
        exitIcon.addEventListener('mouseover', function () {
          arrow.style.left = '28%';
        });
      }
    
      const viewQRIcon = document.querySelector('.view-icon.view-qr-icon') as HTMLElement;
      if (viewQRIcon && arrow) {
        viewQRIcon.addEventListener('mouseover', function () {
          arrow.style.left = '26%';
        });
      }
    
      const viewSettingsIcon = document.querySelector('.view-icon.view-settings-icon') as HTMLElement;
      if (viewSettingsIcon && arrow) {
        viewSettingsIcon.addEventListener('mouseover', function () {
          arrow.style.left = '28%';
        });
      }
    

      const previewPath = window.location.href;

      const toolbar = document.querySelector('.toolbar') as HTMLElement;
      const deviceWrapper = document.getElementById('deviceWrapper') as HTMLElement;
      const hrzPreview = document.querySelector('.hrz-preview') as HTMLElement;
      
      if (previewPath.indexOf('&isFromSB=1') > -1) {
        if (toolbar) toolbar.style.display = 'none';
        if (deviceWrapper) deviceWrapper.style.marginTop = '0px';
        if (hrzPreview) hrzPreview.style.display = 'block';
        document.body.classList.add('SBPreview');
      } else {
        if (hrzPreview) hrzPreview.style.display = 'none';
        if (toolbar) toolbar.style.display = 'block';
        document.body.classList.add('PMPreview');
      }
      
 
    });

    const newWindowLinks = document.querySelectorAll('.new-window');

      newWindowLinks.forEach(link => {
        link.addEventListener('click', function () {
          const path = window.location.href.replace('&isFromSB=1', '');
          window.open(path, '_blank');
        });
      });



      const iframes = document.querySelectorAll('iframe');

      iframes.forEach(iframe => {
        iframe.addEventListener('load', function () {
          document.title = ''; // You can access iframe title if needed using iframe.contentDocument.title
    
          const activeSwitches = document.querySelectorAll('.toggle-switch-btn.active-switch');
          activeSwitches.forEach(toggle => {
            const switchCheck = toggle.querySelector('.switch-check');
            if (switchCheck) {
              switchCheck.classList.add('switch-yes');
              switchCheck.classList.remove('switch-no');
            }
          });
        });
      });


      const toggleSwitches = document.querySelectorAll('.toggle-switch-btn');

      toggleSwitches.forEach(toggle => {
        toggle.addEventListener('mousedown', function (event) {
          const settingsIcon = document.getElementById('settings-icon');
          settingsIcon?.classList.remove('settings-open');
    
          if (toggle.classList.contains('disabled-switch')) {
            event.preventDefault();
            return false;
          }
    
          const path = window.location.href;
          const querystring = path.split('?');
          const input = toggle.querySelector('input');
          if (!input) return;
    
          const idCheck = input.id;
          let msg = '';
          if (idCheck === 'hiddnQCheck' || idCheck === 'vr_hiddnQCheck') {
            msg = 'show hidden questions';
          } else if (idCheck === 'CQCheck' || idCheck === 'vr_CQCheck') {
            msg = 'bypass logic';
          }
    
          const isAssessment = (toggle as any).isAssessment; // TypeScript: refine this if needed
          const strMessage = isAssessment
            ? 'Choosing to modify this setting will restart your assessment.'
            : 'Choosing to modify this setting will restart your survey.';
    
          if (!confirm(strMessage)) {
            event.preventDefault();
            return false;
          }
    
          const switchHandle = toggle.querySelector('.switch-handle');
          const switchCheck = toggle.querySelector('.switch-check');
    
          if (!input.checked) {
            input.checked = true;
            input.setAttribute('data-active', 'on');
            toggle.classList.toggle('active-switch');
            switchHandle?.classList.toggle('float-r');
            switchCheck?.classList.remove('switch-no');
            switchCheck?.classList.add('switch-yes');
    
            if (idCheck === 'mandatoryCheck' || idCheck === 'vr_mandatoryCheck') {
              self.previewData.isManditorySkip = true;
            } else if (idCheck === 'hiddnQCheck' || idCheck === 'vr_hiddnQCheck') {
              self.previewData.isShowHiddenQN = true;
            } else if (idCheck === 'CQCheck' || idCheck === 'vr_CQCheck') {
              self.previewData.isByPassLogic = true;
            }
          } else {
            input.checked = false;
            input.setAttribute('data-active', 'off');
            toggle.classList.toggle('active-switch');
            switchHandle?.classList.toggle('float-r');
            switchCheck?.classList.remove('switch-yes');
            switchCheck?.classList.add('switch-no');
    
            if (idCheck === 'mandatoryCheck' || idCheck === 'vr_mandatoryCheck') {
              self.previewData.isManditorySkip = false;
            } else if (idCheck === 'hiddnQCheck' || idCheck === 'vr_hiddnQCheck') {
              self.previewData.isShowHiddenQN = false;
            } else if (idCheck === 'CQCheck' || idCheck === 'vr_CQCheck') {
              self.previewData.isByPassLogic = false;
            }
          }
    
          self.previewData.PreviewPropChange = true;
          self.previewData.PrevPgNo = 0;
          self.changeDetect.detectChanges();
    
          // Close the preview settings menu after a short delay
          setTimeout(() => {
            document.querySelector('.settings-menu')?.classList.toggle('drop-menu');
            document.querySelector('.view-icon.view-settings-icon')?.classList.remove('active');
            const formatList = document.getElementById('hrz-formatList');
            const previewContainer = document.getElementById('hrz-preview-container');
            formatList?.setAttribute('style', 'display: none;');
            previewContainer?.setAttribute('style', 'display: none;');
          }, 300);
        });
      });

      const settingsIcon = document.getElementById('settings-icon');
      const previewContainer = document.getElementById('hrz-preview-container');
      const formatList = document.getElementById('hrz-formatList');
    
      settingsIcon?.addEventListener('click', () => {
        if (previewContainer) {
          previewContainer.classList.toggle('hrz-drop-menu');
        }
    
        if (formatList) {
          formatList.style.display = 'none';
        }
      });

      const viewSettings = document.querySelector('.view-settings');
      
    
      viewSettings?.addEventListener('click', () => {
        const settingsMenu = document.querySelector('.settings-menu');
      const settingsIcon = document.querySelector('.view-icon.view-settings-icon');
        settingsMenu?.classList.toggle('drop-menu');
        settingsIcon?.classList.toggle('active');
    
        // Simulate tooltip enable/disable — requires a tooltip library or custom implementation.
        if (settingsIcon?.classList.contains('active')) {
          settingsIcon?.setAttribute('data-tooltip-disabled', 'true');
        } else {
          settingsIcon?.removeAttribute('data-tooltip-disabled');
        }
      });

      const closeModal = document.querySelector('.close-modal') as HTMLElement;
      const qrcodeModal = document.querySelector('.qrcode-modal') as HTMLElement;
      const modalOverlay = document.querySelector('.modal-overlay') as HTMLElement;
      const pmPreview = document.querySelector('.PMPreview') as HTMLElement;
    
      closeModal?.addEventListener('click', () => {
        if (qrcodeModal) qrcodeModal.style.display = 'none';
        if (modalOverlay) modalOverlay.style.display = 'none';
        if (pmPreview) pmPreview.classList.remove('previewQROpen');
      });
      document.addEventListener('DOMContentLoaded', () => {
        const toggleSwitchBtns = document.querySelectorAll('.toggle-switch-btn');
        const disabledSwitchBtns = document.querySelectorAll('.toggle-switch-btn.disabled-switch');
        const viewSettings = document.querySelector('.view-settings') as HTMLElement;
      
        // Hide the closest .content-item of the disabled switch buttons
        disabledSwitchBtns.forEach(btn => {
          const closestContentItem = btn.closest('.content-item') as HTMLElement;
          if (closestContentItem) {
            closestContentItem.style.display = 'none';
          }
        });
      
        // Check if there is exactly one enabled toggle switch button
        if (toggleSwitchBtns.length - disabledSwitchBtns.length === 1) {
          toggleSwitchBtns.forEach(btn => {
            const closestContentItem = btn.closest('.content-item') as HTMLElement;
            if (closestContentItem) {
              closestContentItem.style.border = 'none';
            }
          });
        }
      
        // If all toggle switch buttons are disabled, hide the .view-settings
        if (toggleSwitchBtns.length - disabledSwitchBtns.length === 0 && viewSettings) {
          viewSettings.style.display = 'none';
        }
      });
      

      document.addEventListener('mousedown', handleOutsideClick);
      document.addEventListener('touchstart', handleOutsideClick);
      
      function handleOutsideClick(e: Event) {
        const target = e.target as Node;
        const settingsMenu = document.querySelector('.settings-menu');
        const viewIcon = document.querySelector('.view-icon.view-settings-icon');
        const tooltip = document.querySelector('.ui-tooltip.preview-tooltip');
      
        const isInsideSettingsMenu = settingsMenu?.contains(target);
        const isInsideViewIcon = viewIcon?.contains(target);
        const isInsideTooltip = tooltip?.contains(target);
      
        if (!isInsideSettingsMenu && !isInsideViewIcon && !isInsideTooltip) {
          settingsMenu?.classList.remove('drop-menu');
          viewIcon?.classList.remove('active');
        }
      }

      const previewIcon = document.querySelector('.preview-mode-msg-icon');
      const tooltip = document.querySelector('.preview-msg-tooltip');
      
      if (previewIcon && tooltip) {
        previewIcon.addEventListener('mouseenter', () => {
          (tooltip as HTMLElement).style.display = 'block';
        });
      
        previewIcon.addEventListener('mouseleave', () => {
          (tooltip as HTMLElement).style.display = 'none';
        });
      }


      document.addEventListener('DOMContentLoaded', () => {
        const self = this;
      
        // Stop propagation on .preview-got-it-btn click
        const gotItBtns = document.querySelectorAll('.preview-got-it-btn');
        gotItBtns.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.stopPropagation();
          });
        });
      
        // Hide format lists when clicking outside
        document.addEventListener('click', (event) => {
          const target = event.target as HTMLElement;
          if (!target.closest('#dvParticipationFormat')) {
            const formatList1 = document.getElementById('formatList');
            const formatList2 = document.getElementById('formatList12');
            formatList1?.style.setProperty('display', 'none');
            formatList2?.style.setProperty('display', 'none');
          }
        });
      
        // Conditionally hide elements
        if ((self as any).isEx) {
          const qrIcon = document.querySelectorAll('.qrcode-icon');
          const viewSettings = document.querySelectorAll('.view-settings');
      
          qrIcon.forEach(el => (el as HTMLElement).style.display = 'none');
          viewSettings.forEach(el => (el as HTMLElement).style.display = 'none');
        }
      
        // Adjust transform based on screen height
        const screenHeight = window.screen.height;
        const previewOptions = document.querySelectorAll('.preview-floating-options');
      
        previewOptions.forEach((el) => {
          const element = el as HTMLElement;
          if (screenHeight <= 650) {
            element.style.transform = 'translateY(55%)';
          } else if (screenHeight < 700 && screenHeight > 650) {
            element.style.transform = 'translateY(90%)';
          } else if (screenHeight === 720) {
            element.style.transform = 'translateY(40%)';
          }
        });
      
        // Close alert
        const closeBtn = document.getElementById('close-btn');
        closeBtn?.addEventListener('click', () => {
          closeAlert('', false);
        });
      
        // Call external function
        setBgImgDivInPreview();
      });
      

    /*for closing alert required in javascript*/
    function closeAlert(divPlatAlert, isAutoClose) {
      if (divPlatAlert != undefined && divPlatAlert != '') {
        if (isAutoClose === true && divPlatAlert.classList.contains('DoNotAutoClose')) {
            return;
          }
        const alertDiv = document.getElementById(divPlatAlert);
        if (alertDiv) {
          // Set initial styles for transition
          alertDiv.style.transition = 'right 0.75s ease';
          alertDiv.style.right = '-1000px';
        
          // Wait for the animation to finish (750ms)
          setTimeout(() => {
            alertDiv.style.display = 'none';
            alertDiv.style.right = '0px'; // Reset position
            alertDiv.style.transition = ''; // Optional: remove transition
          }, 750);
        }
        
      } else {
       const obj = document.getElementsByClassName('Plat_Alert');
        if (obj.length > 0 && isAutoClose === true && obj[0].classList.contains('DoNotAutoClose')) {
          return;
        }
        for (let i = 0; i < obj.length; i++) {
          const el = obj[i] as HTMLElement;
          if (el) {
            el.style.transition = 'right 0.75s ease';
            el.style.right = '-1000px';
        
            // Create a closure to retain the reference to each element
            setTimeout(() => {
              el.style.display = 'none';
              el.style.right = '0px';
              el.style.transition = ''; // Optional: clean up
            }, 750);
          }
        }
      }
    }

    function setBgImgDivInPreview(): void {
      const previewTablet = document.querySelector('.preview--tablet') as HTMLElement;
    
      if (previewTablet) {
        const iframe = previewTablet.querySelector('#previewViewport') as HTMLIFrameElement;
    
        if (iframe?.contentDocument) {
          const imageDiv = iframe.contentDocument.querySelector('.page-bg-img') as HTMLElement;
    
          if (imageDiv) {
            imageDiv.style.width = 'calc(100% - 18px)';
            imageDiv.style.height = 'calc(100% - 13px)';
            imageDiv.style.margin = '13px 0px 0px 18px';
          } else {
            // Retry after delay if image is not yet loaded
            setTimeout(() => setBgImgDivInPreview(), 500);
          }
        } else {
          // Retry after delay if iframe is not yet available
          setTimeout(() => setBgImgDivInPreview(), 500);
        }
      }
    }
    
    window.onload = () => {
      const mobileIframe = document.querySelector('.preview--mobile #previewViewport') as HTMLIFrameElement;
      const tabletIframe = document.querySelector('.preview--tablet #previewViewport') as HTMLIFrameElement;
    
      if (mobileIframe?.contentDocument) {
        const mobileHtml = mobileIframe.contentDocument.documentElement;
        const styleMobile = mobileIframe.contentDocument.createElement('style');
        styleMobile.textContent = 'html { border-radius: 30px; }';
        mobileHtml.appendChild(styleMobile);
      }
    
      if (tabletIframe?.contentDocument) {
        const tabletHtml = tabletIframe.contentDocument.documentElement;
        const styleTablet = tabletIframe.contentDocument.createElement('style');
        styleTablet.textContent = 'html { border-radius: 6px; }';
        tabletHtml.appendChild(styleTablet);
      }
    };
    
  }
  onMouseOver() {
    const tooltipTriggerClasses = [
      'skip-mandatory',
      'show-hidden',
      'skip-logic'
    ];
    
    tooltipTriggerClasses.forEach(cls => {
      const elements = document.querySelectorAll(`span.more-info-parent.${cls}`);
      elements.forEach(el => {
        el.addEventListener('mouseover', () => {
          const tooltips = document.querySelectorAll('.ui-tooltip');
          tooltips.forEach(tooltip => {
            tooltip.classList.add('preview-tooltip');
            if (!tooltip.querySelector('.hdn-icn-div')) {
              const iconDiv = document.createElement('div');
              iconDiv.className = 'hdn-icn-div';

              const img = document.createElement('img');
              img.className = 'hdn-icn-img';
              img.width = 25;
              img.height = 25;
              img.setAttribute('border', '0');

              // Set image source based on tooltip class
              if (cls === 'skip-mandatory') {
                img.src = 'assets/images/preview/skip-mandatory.svg';
              } else if (cls === 'show-hidden') {
                img.src = 'assets/images/preview/show-hidden.svg';
              } else if (cls === 'skip-logic') {
                img.src = 'assets/images/preview/skip-logic.svg';
              }

              iconDiv.appendChild(img);
              tooltip.prepend(iconDiv);
            }
          });
        });
      });
    });
  }
  checkviewport(viewport: string) {
    const surveyForm = document.getElementById('surveyFrom');
    const ddPreview = document.getElementById('ddPreview') as HTMLInputElement;
    const hdnCurrentLang = document.getElementById('hdnCurrentLang') as HTMLInputElement;
    const hdnOkayGotIt = document.getElementById('hdnOkayGotIt') as HTMLInputElement;
    const deviceWrapper = document.getElementById('deviceWrapper');
    const body = document.body;
  
    if (surveyForm) surveyForm.style.display = 'none';
    if (ddPreview) ddPreview.value = '1';
    if (hdnCurrentLang) hdnCurrentLang.value = '-1';
    if (hdnOkayGotIt) hdnOkayGotIt.value = '0';
  
    this.previewData.ViewportToggle = this.previewData.ViewportToggle === 1 ? 0 : 1;
    this.previewData.surveyFormat = 0;
  
    const removeClasses = (...ids: string[]) => {
      ids.forEach(id => {
        const el = document.getElementById(id);
        if (el) el.className = el.className
          .replace(/view-web--active|view-mobile--active|view-ipad--active|active-icon/g, '')
          .trim();
      });
    };
  
    if (deviceWrapper) {
      deviceWrapper.classList.remove('preview--web', 'preview--mobile', 'preview--tablet');
      deviceWrapper.removeAttribute('style');
    }
  
    switch (viewport) {
      case 'tablet':
        deviceWrapper?.classList.add('preview--tablet');
        document.getElementById('tablet')?.classList.add('view-icon', 'view-ipad--active');
        document.getElementById('vr_tablet')?.classList.add('active-icon');
        removeClasses('web', 'mobile', 'vr_web', 'vr_mobile');
        this.previewData.viewport = 'tablet';
        break;
  
      case 'mobile':
        deviceWrapper?.classList.add('preview--mobile');
        body.classList.add('MobDevicePreview');
        document.getElementById('mobile')?.classList.add('view-icon', 'view-mobile--active');
        document.getElementById('vr_mobile')?.classList.add('active-icon');
        removeClasses('web', 'tablet', 'vr_web', 'vr_tablet');
        this.previewData.viewport = 'mobile';
        break;
  
      case 'web':
        deviceWrapper?.classList.add('preview--web');
        body.classList.remove('MobDevicePreview');
        document.getElementById('web')?.classList.add('view-icon', 'view-web--active');
        document.getElementById('vr_web')?.classList.add('active-icon');
        removeClasses('mobile', 'tablet', 'vr_mobile', 'vr_tablet');
        this.previewData.viewport = 'web';
        break;
    }
  
    this.previewData.PrevPgNo = 1;
    this.previewData.isPrevPgChnge = false;
  }
  

  ShowPreviewMessage(isPreviewPage, hdnIsAssessmentSurvey, strPreviewTime) {
    if (isPreviewPage == 'true') {
      if (hdnIsAssessmentSurvey == 'true') {
        this.strPreviewMsg =
          'You are previewing this page only. Any page to page functions like Piping and Branching may not appear. To preview these functions, please click Preview Assessment.';
      } else {
        this.strPreviewMsg =
          'You are previewing this page only. Any page to page functions like Piping and Branching may not appear. To preview these functions, please click Preview Survey.';
      }
    } else {
      this.strPreviewMsg = 'This is only a preview. Your answers will not be recorded.';
    }
    this.strPreviewTime = strPreviewTime;
  }

  loadViewPort(viewport: string) {
    const ddPreviewLoad = document.getElementById('ddPreview') as HTMLInputElement;
    if (ddPreviewLoad) {
      ddPreviewLoad.value = '1';
    }
    let PreviewURL = window.location.href;
    PreviewURL = PreviewURL.replace('&surveyFormat=0', '')
      .replace('&surveyFormat=1', '')
      .replace('&surveyFormat=2', '');
    if (window.location.href.indexOf('viewport') > -1) {
      (PreviewURL = PreviewURL.replace('web', viewport)
        .replace('mobile', viewport)
        .replace('tablet', viewport));
        window.location.replace(PreviewURL);
    } else {
      window.location.replace(PreviewURL + '&viewport=' + viewport);
    }
  }

  loadSurvey() {
    const ddPreviewLoadSurvey = document.getElementById('ddPreview') as HTMLInputElement;
    if (ddPreviewLoadSurvey) {
      ddPreviewLoadSurvey.value = '1';
    }
    const currentUrl = new URL(window.location.href);
    // Update the 'surveyFormat' parameter
    currentUrl.searchParams.set('surveyFormat', '0');
    // Replace the current URL with the updated one
    window.history.replaceState(null, '', currentUrl.toString());
    if (window.location.href.indexOf('surveyFormat') > -1) {
      window.location.replace(
        window.location.href
          .replace('&surveyFormat=0', '')
          .replace('&surveyFormat=1', '')
          .replace('&surveyFormat=2', ''),
      );
    } else {
      window.location.replace(window.location.href);
    }
  }

  SelectedValue(event: any) {
    let value = event.target.value;
    this.previewData.isPrevPgChnge = true;
    if (value == -1) {
      this.previewData.PrevPgNo = 999;
    } else {
      this.previewData.PrevPgNo = value;
    }
    this.previewData.PreviewPropChange = !this.previewData.PreviewPropChange;
    this.changeDetect.detectChanges();
  }

  setFormatSelect(event: any, customVal: string) {
    event.preventDefault();
    event.stopPropagation();
    var surveyFormat = parseInt(customVal);
    // Set the value of #ddPreview to 1
    const ddPreview = document.getElementById('ddPreview') as HTMLInputElement;
    if (ddPreview) {
      ddPreview.value = '1'; // Value should be a string in JavaScript
    }

    // Set the text content of elements with class 'surveyFormatDDValue'
    const surveyFormatDDValueElements = document.querySelectorAll('.surveyFormatDDValue');
    surveyFormatDDValueElements.forEach((element) => {
      if (event.target && event.target instanceof HTMLElement) {
        element.textContent = event.target.textContent || ''; // Set the text content of each element
      }
    });

    // Set the value of #ddParticipationFormat to customVal
    const ddParticipationFormat = document.getElementById('ddParticipationFormat') as HTMLInputElement;
    if (ddParticipationFormat) {
      ddParticipationFormat.value = customVal;
    }

    // Hide the elements with ids #formatList and #formatList12
    const formatList = document.getElementById('formatList');
    const formatList12 = document.getElementById('formatList12');
    if (formatList) {
      formatList.style.display = 'none'; // Hide the element
    }
    if (formatList12) {
      formatList12.style.display = 'none'; // Hide the element
    }
    var strMessage = '';

    if (this.previewSettings.isAssessment) {
      strMessage =
        'Modifying the Display Mode will reset all preview settings and restart the assessment.';
    } else {
      strMessage =
        'Modifying the Display Mode will reset all preview settings and restart the survey.';
    }

    if (!confirm(strMessage)) {
      return false;
    }
    this.previewData.surveyFormat = surveyFormat;
    this.previewData.PreviewPropChange = true;
    if (window.location.href.indexOf('surveyFormat') > -1) {
      window.location.replace(
        window.location.href
          .replace('&surveyFormat=0', '&surveyFormat=' + surveyFormat)
          .replace('&surveyFormat=1', '&surveyFormat=' + surveyFormat)
          .replace('&surveyFormat=2', '&surveyFormat=' + surveyFormat),
      );
    } else {
      window.location.replace(window.location.href + '&surveyFormat=' + surveyFormat);
    }
    setTimeout(function () {
      const hrzFormatList = document.getElementById('hrz-formatList');
      const hrzPreviewContainer = document.getElementById('hrz-preview-container');
      
      if (hrzFormatList) {
        hrzFormatList.style.display = 'none'; // Hide the element
      }

      if (hrzPreviewContainer) {
        hrzPreviewContainer.style.display = 'none'; // Hide the element
      }
    }, 300);
  }

  GetQr() {
    let strDecodeUrl = 'getPreviewQRCode?k=' + this.k;
    this.service
      .postDataUsingPromise(
        strDecodeUrl,
        JSON.stringify(
          EncryptionAndDecryption.EncryptionData('123456$#@$^@1ERF', window.location.href),
        ),
      )
      .then(
        async (data) => {
          const arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await data);
          this.QRImagePath = await arrData;
          setTimeout(() => {
            this.previewData.PreviewPropChange = true;
            this.changeDetect.detectChanges();
          // Show the qrcode-modal and modal-overlay elements
          const qrcodeModal = document.querySelector('.qrcode-modal') as HTMLElement;
          const modalOverlay = document.querySelector('.modal-overlay') as HTMLElement;
          const pmPreview = document.querySelector('.PMPreview') as HTMLElement;

          // Set display to block for qrcode-modal and modal-overlay
          if (qrcodeModal) {
            qrcodeModal.style.display = 'block';
          }

          if (modalOverlay) {
            modalOverlay.style.display = 'block';
          }

          // Add 'previewQROpen' class to PMPreview element
          if (pmPreview) {
            pmPreview.classList.add('previewQROpen');
          }
          }, 10);
        },
        (error) => {
          this.errorsHandlerService.handleError(error);
          if (error.name == 'HttpErrorResponse') {
            window.location.replace('/sd?err=1&ng=2&cn=0');
          }
        },
      );
  }
  formListShow() {
    const formatListShow = document.getElementById('formatList') as HTMLElement;
    formatListShow.style.display = 'block';
  }
  formListHrzShow(){
    const formatListShow = document.getElementById('hrz-formatList') as HTMLElement;
    formatListShow.style.display = 'block';
  }
}
